module.exports = __webpack_public_path__ + "static/img/iconfont.2f70c90.svg";


//////////////////
// WEBPACK FOOTER
// ./static/iconfonts/iconfont.svg?t=1592806397367
// module id = fkJl
// module chunks = 71